import { ObjectUtils } from '@rp/utils';

import { PayoutHistoryRequest } from '../models';

const toRestHistoryParams = ({ sorting }: PayoutHistoryRequest) => {
  return ObjectUtils.objectToQueryString(
    ObjectUtils.stripEmptyFields(
      {
        sorting,
      },
      true,
      true,
    ),
  );
};

export const PayoutHistoryAdapter = {
  toRestHistoryParams,
};
